import * as PopoverPrimitive from '@radix-ui/react-popover';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { PANEL, PANEL_MOTION } from './styles';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;

type PanelProps = ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & { children: ReactNode };

export function PopoverPanel({ className, sideOffset = 6, align = 'start', collisionPadding = 8, children, ...props }: PanelProps) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content sideOffset={sideOffset} align={align} collisionPadding={collisionPadding} className={cn(PANEL, PANEL_MOTION, 'origin-(--radix-popover-content-transform-origin) focus:outline-none', className)} {...props}>
        {children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
}
